<template>
	<div class="container member-bank-form">
		<div class="common-header-wrap">
			<mt-header :title="getTitle" class="common-header">
				<mt-button slot="left" icon="back" @click="goBack"></mt-button>
			</mt-header>
		</div>
    <div class="main-content">
		<flex-line :show-border="true">
			<span>账户类型</span>
			<div slot="right">
				<mt-radio
						v-model="bank_info.memberbank_type"
						:options="memberbank_type_options">
				</mt-radio>
			</div>
		</flex-line>
		<flex-line class="field-line" :show-border="true"><span class="field-name">开户名</span><div class="field-line-right" slot="right"><input class="field-input" v-model="bank_info.memberbank_truename" /></div></flex-line>
		<flex-line v-if="bank_info.memberbank_type=='bank'" class="field-line" :show-border="true"><span class="field-name">开户行</span><div class="field-line-right" slot="right"><input class="field-input" v-model="bank_info.memberbank_name" /></div></flex-line>
		<flex-line class="field-line" :show-border="true"><span class="field-name">账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="bank_info.memberbank_no" /></div></flex-line>
	<div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submit">{{getSumitTitle}}</div></div>
	</div>

	</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { getBankInfo, addBank, editBank } from '../../../api/memberBank'
import flexLine from '../../flexLine'
export default {
  components:{
  flexLine,
  },
  computed: {
    isAddMode () {
      let mode = this.$route.query.action
      // add: 添加地址，edit: 编辑地址
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return '新增提现账户'
      } else {
        return '修改提现账户'
      }
    },
    getSumitTitle () {
      return '保存'
    }
  },
  data () {
    return {
      memberbank_type_options: [
        {
          label: '银行',
          value: 'bank'
        },
        {
          label: '支付宝',
          value: 'alipay'
        }
      ],
      memberbank_id: 0,
      bank_info: {
        memberbank_type: 'bank',
        memberbank_truename: '',
        memberbank_name: '',
        memberbank_no: ''
      }
    }
  },
  created: function () {
    if (!this.isAddMode) {
      this.memberbank_id = this.$route.query.memberbank_id
      getBankInfo(this.memberbank_id).then(res => {
        this.bank_info.memberbank_type = res.result.bank_info.memberbank_type
        this.bank_info.memberbank_truename = res.result.bank_info.memberbank_truename
        this.bank_info.memberbank_name = res.result.bank_info.memberbank_name
        this.bank_info.memberbank_no = res.result.bank_info.memberbank_no
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    submit () {
      if (this.isAddMode) {
        Indicator.open()
        addBank(this.bank_info).then(
          (response) => {
            Indicator.close()
            this.$router.push({ name: 'MemberBankList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editBank(this.bank_info, this.memberbank_id).then(
          (response) => {
            Indicator.close()
            this.$router.push({ name: 'MemberBankList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
    }
  }
}
</script>
<style lang="scss">
	.member-bank-form{
		.mint-radiolist {
			display: flex;
			.mint-cell {
				flex: 1;
				.mint-radio-input:checked + .mint-radio-core {
					background-color: $primaryColor !important;
					border-color: $primaryColor !important;
				}
				&:after{display: none}
			}
		}
	}

</style>
<style lang="scss" scoped>
	.main-content{background: #fff;padding:0 $pageSpace}
	.right-arrow{transform: rotate(-90deg);color:#ddd;font-size:$fontSize;display: inline-block;}
	.input-wrap{position: relative;
		i{position: absolute;right:0;top:0;line-height: 2.4rem;display: block;width:2rem;text-align: center;font-size:$h1}
	}

</style>
